import { get } from 'lodash';

export const getServerTime = state => get(state, 'CommonState.serverTime.time');

export const getServerTimeError = state =>
  get(state, 'CommonState.serverTime.error');

export const getServerTimeFetching = state =>
  get(state, 'CommonState.serverTime.fetching');



// WEBPACK FOOTER //
// ./src/state/serverTime/selectors.js